<template>
  <div>
    <h3 class="chart-title">
      {{ propChartData.title }}
    </h3>
    <div class="chart-holder">
      <LineChartGenerator
        :chart-options="chartOptions"
        :chart-data="chartData"
        :chart-id="chartId"
        :dataset-id-key="datasetIdKey"
        :plugins="plugins"
        :css-classes="cssClasses"
        :styles="styles"
        :width="width"
        :height="height"
      />
    </div>
  </div>
</template>

<script>
import { Line as LineChartGenerator } from "vue-chartjs/legacy";
import ChartPropsWatcher from "@/mixins/ChartPropsWatcher";

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement,
} from "chart.js";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement
);

export default {
  name: "LineChart",
  components: {
    LineChartGenerator,
  },
  props: {
    propChartData: {
      type: Object,
      default: () => {},
    },
    chartId: {
      type: String,
      default: "line-chart",
    },
    datasetIdKey: {
      type: String,
      default: "label",
    },
    width: {
      type: Number,
      default: 400,
    },
    height: {
      type: Number,
      default: 400,
    },
    cssClasses: {
      default: "",
      type: String,
    },
    styles: {
      type: Object,
      default: () => {},
    },
  },
  mixins: [ChartPropsWatcher],
  data() {
    return {
      values: [],
      iconsLabel: [
        require("@/assets/images/charts/chart-pleasure/pleasure-icon-1.svg"),
        require("@/assets/images/charts/chart-pleasure/pleasure-icon-2.svg"),
        require("@/assets/images/charts/chart-pleasure/pleasure-icon-3.svg"),
        require("@/assets/images/charts/chart-pleasure/pleasure-icon-4.svg"),
        require("@/assets/images/charts/chart-pleasure/pleasure-icon-5.svg"),
        require("@/assets/images/charts/chart-pleasure/pleasure-icon-6.svg"),
        require("@/assets/images/charts/chart-pleasure/pleasure-icon-7.svg"),
        require("@/assets/images/charts/chart-pleasure/pleasure-icon-8.svg"),
        require("@/assets/images/charts/chart-pleasure/pleasure-icon-9.svg"),
        require("@/assets/images/charts/chart-pleasure/pleasure-icon-10.svg"),
      ],
      plugins: [
        {
          afterDraw: (chart) => {
            let ctx = chart.ctx;
            let yAxis = chart.scales.y;

            yAxis.ticks.forEach((value, index) => {
              var y = yAxis.getPixelForTick(index);
              var image = new Image();
              image.src = this.iconsLabel[index];
              ctx.drawImage(image, 10, y - 12);
            });
          },
        },
      ],
      chartOptions: {
        layout: {
          padding: {
            top: 25,
            left: 15,
            right: 20,
            bottom: -20,
          },
        },
        responsive: true,
        maintainAspectRatio: false,

        plugins: {
          legend: {
            display: false,
          },
        },
        scales: {
          x: {
            title: {
              display: true,
              font: {
                size: 20,
              },
            },
            grid: {
              display: false,
            },
            ticks: {
              beginAtZero: false,
              source: "data",
              autoSkip: true,
              maxTicksLimit: 7,
            },
          },
          y: {
            title: {
              display: true,
            },
            ticks: {
              display: false,
            },
            grid: {
              color: "#D8D8D8",
              drawBorder: false,
            },
            suggestedMin: 1,
            suggestedMax: 10,
          },
        },
      },
    };
  },
  computed: {
    chartData() {
      return {
        labels: this.convertedLabels,
        datasets: [
          {
            label: false,
            pointStyle: false,
            pointRadius: 3,
            data: this.values,
            backgroundColor: (ctx) => {
              const canvas = ctx.chart.ctx;
              const gradient = canvas.createLinearGradient(0, 0, 0, 290);

              gradient.addColorStop(0.1, "#B9DDAF");
              gradient.addColorStop(0.2, "#B9DDAF");
              gradient.addColorStop(0.3, "#D2EECA");
              gradient.addColorStop(0.4, "#E3F0DF");
              gradient.addColorStop(0.5, "#F5EEE8");
              gradient.addColorStop(0.6, "#F2E3D7");
              gradient.addColorStop(0.7, "#E1D1C4");
              gradient.addColorStop(0.8, "#E3D0C0");
              gradient.addColorStop(0.9, "#D8C4B3");
              gradient.addColorStop(1.0, "#C6B3A3");

              return gradient;
            },
            borderColor: (ctx) => {
              const canvas = ctx.chart.ctx;
              const gradient = canvas.createLinearGradient(0, 0, 0, 290);

              gradient.addColorStop(0.1, "#B9DDAF");
              gradient.addColorStop(0.2, "#B9DDAF");
              gradient.addColorStop(0.3, "#D2EECA");
              gradient.addColorStop(0.4, "#E3F0DF");
              gradient.addColorStop(0.5, "#F5EEE8");
              gradient.addColorStop(0.6, "#F2E3D7");
              gradient.addColorStop(0.7, "#E1D1C4");
              gradient.addColorStop(0.8, "#E3D0C0");
              gradient.addColorStop(0.9, "#D8C4B3");
              gradient.addColorStop(1.0, "#C6B3A3");

              return gradient;
            },
          },
        ],
      };
    },
  },
};
</script>
